import { render, staticRenderFns } from "./AnexosPage.vue?vue&type=template&id=9acaafd0"
import script from "./AnexosPage.js?vue&type=script&lang=js&external"
export * from "./AnexosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports